import './src/theme/destyle.css'
import './src/theme/global.css'
import 'keen-slider/keen-slider.min.css'

import { ThemeProvider } from './src/theme'

export const wrapPageElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}

export const shouldUpdateScroll = () => {
  return false
}
